/* eslint-disable no-magic-numbers */

import {
	filesize
} from "widgets/forms/validators/Assets";
import { requiredAsset, validateUnlessExternalRender } from "social/validators/validators";
import {
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { uniquePACVariableName } from "widgets/social2/validators/utils";

import { MAX_IMAGE_BYTES } from "./consts";

export const staticValidators = {
	image: [uniquePACVariableName],
	headline: [uniquePACVariableName],
	primaryText: [uniquePACVariableName],
	landingPage: [uniquePACVariableName],
};

export const validators = {
	image: validateUnlessExternalRender([
		requiredAsset,
		filesize({ max: MAX_IMAGE_BYTES }),
	]),
	primaryText: [
		maxLength(2200),
	],
	landingPage: [
		requiredNotNull,
		isURL,
	],
};
